import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { formatKm } from "@/lib/format";

const GREEN = "#00C853";

// Larger "DNA Certified Seal" shown on the vehicle detail page.
export const DnaSeal = ({ car }) => {
  if (!car?.dna_certified) return null;
  return (
    <section data-testid="dna-seal" className="force-dark mt-4 overflow-hidden rounded-2xl border"
      style={{ borderColor: `${GREEN}55`, background: "linear-gradient(180deg,#052e16,#0F2540)" }}>
      <div className="flex items-center gap-4 p-5">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full" style={{ background: `${GREEN}22`, border: `2px solid ${GREEN}` }}>
          <ShieldCheck size={28} style={{ color: GREEN }} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-display text-base font-extrabold" style={{ color: GREEN }}>Données techniques certifiées par lecture directe OBD</div>
          <div className="mt-1 text-sm text-white/80">
            {car.dna_obd_mileage != null && <>Kilométrage vérifié : <span className="font-bold text-white">{formatKm(car.dna_obd_mileage)}</span></>}
            {car.dna_engine_code && <> · Moteur : <span className="font-mono font-bold text-white">{car.dna_engine_code}</span></>}
          </div>
          {car.dna_scan_id && (
            <Link to={`/dna/passport/${car.dna_scan_id}`} data-testid="dna-seal-link"
              className="mt-2 inline-flex items-center gap-1 text-xs font-bold underline" style={{ color: GREEN }}>
              Voir le passeport Digital DNA <ArrowRight size={13} />
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default DnaSeal;
